(function () {
	"use strict";

	var stops = [
		{
			id: "608c23070d7211c31ddee02d",
			eta: null,
			isInTheStop: false,
		},
		{
			id: "608c23060d7211e194dedff1",
			eta: null,
			isInTheStop: false,
		},
	];

	var lon = "-80.1358914";
	var lat = "25.9314559";
	const weatherApikey = "e7cd7118794283223387e02741f41e72";

	var isThere10minutesLessArrival = false;
	var minutes = 5;
	var updateInterval = setInterval(function () {
		getAllStopArrivals();
	}, minutes * 60 * 1000);

	var updateWeatherInterval = setInterval(function () {
        getWeather();
		
	}, 60 * 60 * 1000);

    var updateScheduleInterval = setInterval(function () {
		checkScheduleTime();
	}, 60 * 60 * 1000);

	function getStopArrival(id) {
		let request = new XMLHttpRequest();

		request.onreadystatechange = function () {
			if (request.readyState === 4) {
				if (request.status === 200 || request.status === 201) {
					let stopArrivalJSON = JSON.parse(request.responseText);
					storeStopData(stopArrivalJSON.arrival);
				}
			}
		};

		request.open(
			"Get",
			"http://eta.dynamictrackers.com:300/api/1.0/routes/stop/arrival/" + id
		);
		request.send();
	}

	function storeStopData(stopArrival) {
		for (let i = 0; i < stops.length; i++) {
			if (stops[i].id == stopArrival.stop._id) {
				stops[i].eta = stopArrival.estimatedTime;
				stops[i].isInTheStop = stopArrival.isInTheStop;
			}
		}
		updateScreenStopData();
	}

	function updateScreenStopData() {
		let etas = [];
		let isInTheStop = false;

		for (let i = 0; i < stops.length; i++) {
			if (stops[i].eta != null && !stops[i].isInTheStop) {
				let _eta = moment(stops[i].eta);
				etas.push(_eta);
			}
			if (stops[i].isInTheStop) {
				isInTheStop = true;
			}
		}
		let sortedEtas = etas.sort((a, b) => a.diff(b));

		isThere10minutesLessArrival = false;

		if (isInTheStop) {
			let etaElement0 = document.getElementById("eta0");
			etaElement0.innerHTML =
				'<span class="message">The trolley is in the stop.</span>';
			etaElement0.style.display = "block";

			if (sortedEtas.length > 0) {
				let millisecondsToETA = sortedEtas[0].diff(moment());
				let minutesToETA = Math.round(millisecondsToETA / 60000);
				let etaElement = document.getElementById("eta1");

				etaElement.innerHTML =
					'<span class="trolley-icon"><img src="../img/TrolleyIcon.svg"></span><span class="time">' +
					minutesToETA +
					'</span> <span class="minutes">min</span><span class="capacity">15</span>';
				etaElement.style.display = "block";

				if (minutesToETA <= 10) {
					isThere10minutesLessArrival = true;
				}
			}
		} else {
			for (let i = 0; i < sortedEtas.length; i++) {
				let millisecondsToETA = sortedEtas[i].diff(moment());
				let minutesToETA = Math.round(millisecondsToETA / 60000);
				let etaElement = document.getElementById("eta" + i);

				etaElement.innerHTML =
					'<span class="trolley-icon"><img src="../img/TrolleyIcon.svg"></span><span class="time">' +
					minutesToETA +
					'</span> <span class="minutes">min</span><span class="capacity">15</span>';
				etaElement.style.display = "block";

				if (minutesToETA <= 10) {
					isThere10minutesLessArrival = true;
				}
			}
		}
	}

	function getAllStopArrivals() {
		//console.log("Get All Stop Arrivals " + minutes);
		//console.log(Date());
		for (let i = 0; i < stops.length; i++) {
			getStopArrival(stops[i].id);
		}
		if (isThere10minutesLessArrival && minutes == 5) {
			//console.log("hay un tiempo menor a 10 y el update esta en 5 min");
			clearInterval(updateInterval);
			minutes = 1;
			updateInterval = setInterval(function () {
				//console.log("I am here!");
				getAllStopArrivals();
			}, minutes * 60 * 1000);
		}
		if (!isThere10minutesLessArrival && minutes == 1) {
			//console.log("no hay un tiempo menor a 10 y el update esta en 1 min");
			clearInterval(updateInterval);
			minutes = 5;
			updateInterval = setInterval(function () {
				//console.log("I am here!");
				getAllStopArrivals();
			}, minutes * 60 * 1000);
		}
	}

	function getWeather() {
		let request = new XMLHttpRequest();

		request.onreadystatechange = function () {
			if (request.readyState === 4) {
				if (request.status === 200 || request.status === 201) {
					//console.log(request.responseText)
					let response = JSON.parse(request.responseText);
					updateWeather(response.hourly.slice(0, 6));
				}
			}
		};

		request.open(
			"Get",
			"https://api.openweathermap.org/data/2.5/onecall?lat=" +
				lat +
				"&lon=" +
				lon +
				"&units=imperial&appid=" +
				weatherApikey
		);
		request.send();
	}

	function weatherCode2text(code, isDay) {
        console.log(code);
		let text = "";
		if (code < 300) {
			text = "thunderstorm";
		} else if (code < 400) {
			text = "sprinkle";
		} else if (code < 600) {
			text = "rain";
		} else if (code < 700) {
			text = "snow";
		} else if (code < 800) {
			text = "fog";
		} else if (code == 800 && isDay) {
			text = "day-sunny";
		} else if (code == 800 && !isDay) {
			text = "night-clear";
        } else if (code == 801 && isDay) {
			text = "day-cloudy";
        } else if (code == 801 && isDay) {
			text = "night-partly-cloudy";
		} else if (code < 900) {
			text = "cloudy";
		} else {
		}
		return text;
	}

	function isDayFunction(hour) {
		const dayStart = moment("06:00:00", "HH:mm:ss");
		const dayEnd = moment("17:00:00", "HH:mm:ss");
		return hour.isBetween(dayStart, dayEnd);
	}

    function isInScheduleTime(){
        var now = moment();
        const dayStart = moment("06:00:00", "HH:mm:ss");
		const dayEnd = moment("17:00:00", "HH:mm:ss");
        var day = now.day();
		return now.isBetween(dayStart, dayEnd) && day > 0;
        
    }

	function updateWeather(weatherList) {
		for (let i = 0; i < weatherList.length; i++) {
			let weatherElement = document.getElementById("weather" + i);
			let hour = moment.unix(weatherList[i].dt);
			let isDay = isDayFunction(hour);
			let weather = weatherCode2text(weatherList[i].weather[0].id, isDay);
			let temperature = Math.round(weatherList[i].temp);
			let timeText = i == 0 ? "Now" : hour.format("HH:mm");
			weatherElement.innerHTML =
				"<span>" +
				timeText +
				"</span>" +
				"<span>" +
				'<i class="wi wi-' +
				weather +
				'"></i>' +
				"</span>" +
				"<span>" +
			    temperature +
				"º</span>";
		}
	}

    function checkScheduleTime(){
        let etaInfo = document.getElementById("eta-info");
        let scheduleInfo = document.getElementById("schedule-info");
        if(!isInScheduleTime()){
            etaInfo.style.display = "none";
            scheduleInfo.style.display = "block";
        }else{
            scheduleInfo.style.display = "none";
            etaInfo.style.display = "block";
        }
    }

	getWeather();
	getAllStopArrivals();

    checkScheduleTime();


})();
